import { IconProps } from 'types/icon.type'

export const StripeIcon = (props: IconProps) => {
  return (
    <svg
      width="55"
      height="32"
      viewBox="0 0 55 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Stripe Logo</title>
      <rect x="0.5" width="54" height="32" rx="6" fill="white" />
      <path
        d="M28.99 10.8972L26.48 11.4019V9.49533L28.99 9V10.8972Z"
        fill="#6461FC"
      />
      <path
        d="M18.7899 10.0841L16.3499 10.5701L16.3399 18.0561C16.3399 19.4392 17.4499 20.4579 18.9299 20.4579C19.7499 20.4579 20.3499 20.3177 20.6799 20.1495V18.2523C20.3599 18.3738 18.7799 18.8037 18.7799 17.4205V14.1028H20.6799V12.1121H18.7799L18.7899 10.0841Z"
        fill="#6461FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.5 16.2336C45.5 13.8411 44.26 11.9533 41.89 11.9533C39.51 11.9533 38.07 13.8411 38.07 16.2149C38.07 19.028 39.77 20.4486 42.21 20.4486C43.4 20.4486 44.3 20.1962 44.98 19.8411V17.9719C44.3 18.2897 43.52 18.486 42.53 18.486C41.56 18.486 40.7 18.1682 40.59 17.0654H45.48C45.48 17.0139 45.4836 16.8969 45.4877 16.7622C45.4934 16.579 45.5 16.3628 45.5 16.2336ZM40.5599 15.3458C40.5599 14.2897 41.2499 13.8505 41.8799 13.8505C42.4899 13.8505 43.1399 14.2897 43.1399 15.3458H40.5599Z"
        fill="#6461FC"
      />
      <path
        d="M12.88 13.9813C12.35 13.9813 12.03 14.1215 12.03 14.486C12.03 14.884 12.5807 15.059 13.264 15.2762C14.3778 15.6302 15.8438 16.0963 15.85 17.8224C15.85 19.4953 14.42 20.458 12.34 20.458C11.48 20.458 10.54 20.2991 9.61 19.9252V17.7009C10.45 18.1309 11.51 18.4486 12.34 18.4486C12.9 18.4486 13.3 18.3084 13.3 17.8785C13.3 17.4377 12.703 17.2362 11.9823 16.993C10.8846 16.6225 9.5 16.1552 9.5 14.5981C9.5 12.9439 10.85 11.9533 12.88 11.9533C13.71 11.9533 14.53 12.0748 15.36 12.3832V14.5795C14.6 14.1963 13.64 13.9813 12.88 13.9813Z"
        fill="#6461FC"
      />
      <path
        d="M23.7901 12.8037L23.6301 12.1121H21.4701V20.2897H23.9701V14.7477C24.5601 14.028 25.5601 14.1589 25.8701 14.2617V12.1121C25.5501 12 24.3801 11.7944 23.7901 12.8037Z"
        fill="#6461FC"
      />
      <path
        d="M26.4798 12.1122H28.9899V20.2897H26.4798V12.1122Z"
        fill="#6461FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.2499 12.6822C32.5999 12.3832 33.2299 11.9533 34.2099 11.9533C35.9599 11.9533 37.6099 13.4299 37.6199 16.1402C37.6199 19.1028 35.9899 20.4486 34.1999 20.4486C33.3199 20.4486 32.7899 20.1028 32.4299 19.8598L32.4199 22.5047L29.9199 23V12.1028H32.1199L32.2499 12.6822ZM32.4298 17.9532C32.6698 18.1962 33.0198 18.3925 33.6098 18.3925C34.5298 18.3925 35.1498 17.4579 35.1498 16.2056C35.1498 14.9813 34.5198 14.028 33.6098 14.028C33.0398 14.028 32.6798 14.2149 32.4198 14.486L32.4298 17.9532Z"
        fill="#6461FC"
      />
    </svg>
  )
}
